<template>
    <Modal :visible="$userStore.isPremiumModalVisible" @close="closeModal">
        <div class="d-flex flex-column align-items-center justify-content-center">
            <i
                class="fi fi-lg fi-lock mb-2"
                style="
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 200;
                    color: var(--warning);
                "
            ></i>
            <h2 class="my-1 text-center">This Feature Requires an Upgrade</h2>
            <div class="premium-description my-2 w-100" style="color: var(--neutral-800)">
                To access this feature, please upgrade your dashboard plan.
            </div>
            <div class="actions d-flex gap-2">
                <button class="btn btn-desktop-lg btn-white" @click="closeModal">
                    Maybe Later
                </button>
                <button class="btn btn-desktop-lg btn-primary" @click="goToPlans">
                    View Plans
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { goToPlans as navigateToPlans } from '@/utils/navigation';

export default {
    name: 'PremiumModal',
    components: {
        Modal,
    },
    props: {},
    emits: [],
    methods: {
        closeModal() {
            this.$userStore.togglePremiumModal(false);
        },
        goToPlans() {
            navigateToPlans(this.$router);
            this.closeModal();
        },
    },
};
</script>

<style scoped>
.premium-description {
    text-align: left;
    margin-bottom: var(--space-5);
}

.actions {
    margin-top: var(--space-5);
}

@media (max-width: 767.98px) {
    .actions {
        flex-direction: column;
        width: 100%;
    }
    .actions .btn {
        width: 100%;
    }
}
</style>
